import Vue from 'vue';
import VisitService from '@/services/VisitService';

const filtersKey = 'call-filters';

const Filters = {
  status: '',
  visitorFirstName: '',
  visitorLastName: '',
  prisonerNumber: '',
  after: '',
  before: '',
  sort: '-updated_at',
  skip: 1,
  limit: 10,
  externalCancellation: '',
  visitType: '',
  wingId: '',
};

export default {
  namespaced: true,
  state: {
    filters: { ...Filters },
    defaultFilters: null, // used to set filters back to original
  },
  getters: {},
  mutations: {
    SET_FILTERS(state, value) {
      state.filters = value;

      localStorage.setItem(filtersKey, JSON.stringify(state.filters));
    },
    SET_FILTER_ITEM(state, item) {
      state.filters[item.name] = item.value;

      localStorage.setItem(filtersKey, JSON.stringify(state.filters));
    },
    SET_DEFAULT_FILTERS(state, value) {
      state.defaultFilters = value;
    },
  },
  actions: {
    setFiltersToDefault({ state, commit }) {
      if (state.defaultFilters) {
        commit('SET_FILTERS', state.defaultFilters);
      }
    },
    setFiltersFromLocal({ commit }) {
      const filters = localStorage.getItem(filtersKey);

      if (filters) {
        commit('SET_FILTERS', JSON.parse(filters));
        commit('SET_DEFAULT_FILTERS', JSON.parse(filters));
      }
    },
    clearFilters({ commit }) {
      localStorage.removeItem(filtersKey);
      commit('SET_DEFAULT_FILTERS', null);
      commit('SET_FILTERS', { ...Filters });
    },
    // eslint-disable-next-line no-unused-vars
    async updateExternalCancellation({ commit }, visit) {
      // eslint-disable-next-line no-underscore-dangle
      await VisitService.updateExternalCancellation(visit._id, visit.external_cancellation).then(() => {
        Vue.$toast.success('Updated cancellation value', {
          toastClassName: ['toast-std', 'success-toast'], timeout: 5000,
        });
        return true;
      }).catch(() => {
        Vue.$toast.error('Could not update cancellation value, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      })

      return false;
    },
  },
};
